module.exports = __webpack_public_path__ + "8ac244fcbfd3b734c5d5cc285633154a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Notification.svg
// module id = 1684
// module chunks = 5